import { render, staticRenderFns } from "./resetpass.vue?vue&type=template&id=b6425d2a&"
import script from "./resetpass.vue?vue&type=script&lang=js&"
export * from "./resetpass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports